import { useEffect, useState } from 'react'
import { Flag } from 'lucide-react'
import Modal from '../../../../components/ERP/Modal/Modal'
import { CalendarDatePicker } from '../../../../components/ERP/Calendar/Calendar'
import { patientService } from '../../../../services/patientApi'
import { GOAL_HORIZON } from './therapyFormat'

const EMPTY = {
  title: '',
  horizon: 'curto',
  targetDate: '',
  notes: ''
}

function TherapyGoalModal({ isOpen, patientId, goal, onClose, onSaved }) {
  const [form, setForm] = useState(EMPTY)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!isOpen) return
    setForm(goal ? {
      title: goal.title || '',
      horizon: goal.horizon || 'curto',
      targetDate: goal.target_date ? String(goal.target_date).slice(0, 10) : '',
      notes: goal.notes || ''
    } : EMPTY)
    setError('')
  }, [isOpen, goal])

  const submit = async (event) => {
    event.preventDefault()
    if (!form.title.trim()) {
      setError('Informe a meta.')
      return
    }
    setSaving(true)
    setError('')
    const payload = {
      title: form.title.trim(),
      horizon: form.horizon,
      targetDate: form.targetDate || null,
      notes: form.notes.trim()
    }
    try {
      if (goal?.id) await patientService.updateTherapyGoal(patientId, goal.id, payload)
      else await patientService.addTherapyGoal(patientId, payload)
      onSaved()
      onClose()
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível salvar a meta')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={goal ? 'Editar meta' : 'Nova meta terapêutica'}
      subtitle="Curto ou longo prazo"
      icon={<Flag size={22} />}
      footer={(
        <button type="submit" form="therapy-goal-form" disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar meta'}
        </button>
      )}
    >
      <form id="therapy-goal-form" onSubmit={submit}>
        {error && <p className="patients-alert-strip">{error}</p>}
        <div className="patients-form-grid">
          <div>
            <label htmlFor="therapy-goal-title">Meta *</label>
            <input id="therapy-goal-title" value={form.title} onChange={(event) => setForm((current) => ({ ...current, title: event.target.value }))} placeholder="Ex.: Sentar sem apoio por 2 minutos" maxLength={180} />
          </div>
          <div>
            <label htmlFor="therapy-goal-horizon">Prazo</label>
            <select id="therapy-goal-horizon" value={form.horizon} onChange={(event) => setForm((current) => ({ ...current, horizon: event.target.value }))}>
              {Object.entries(GOAL_HORIZON).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
          <div className="patients-evolution-date">
            <label>Data alvo</label>
            <CalendarDatePicker
              value={form.targetDate}
              onChange={(value) => setForm((current) => ({ ...current, targetDate: value }))}
              title="Data alvo"
              placeholder="Opcional"
            />
          </div>
          <div>
            <label htmlFor="therapy-goal-notes">Observações</label>
            <textarea id="therapy-goal-notes" rows={3} value={form.notes} onChange={(event) => setForm((current) => ({ ...current, notes: event.target.value }))} />
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default TherapyGoalModal
